import { SETTINGS as rentalReturns } from "views/Configuration/settings/rentals/rentalReturns";
import { SETTINGS as rentals } from "views/Configuration/settings/rentals/rentals";

export const SETTINGS = {
  rentals,
  rentalReturns,
};
